import React, { Component } from 'react';
import { GraingerAccountContext } from '../../Context/Context';

import './Services.scss';
import { Row, Column } from '../../Components/Grid/Grid'
import Page from '../../Components/Page/Page'

class Services extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  render() {
    return (
      <Page title='Our Services' shrinkTitle='Services' type='Banner'>
        <Row className='services-container'>
          <Column className='services-top'>
            <p className='services-title'>Tax &amp; Accounting Compliance</p>
            <ul>
              <li>Income Tax Returns</li>
              <li>Business and Instalment Activity Statements</li>
              <li>Accounting Software Implementation and Advice (XERO &amp; MYOB)</li>
              <li>Accounting Software Support</li>
              <li>Cash Flowing Projections</li>
              <li>ATO Assistance</li>
            </ul>
          </Column>
          <Column className='services-middle'>
            <p className='services-title'>Advisory Services</p>
            <ul>
              <li>Tax Consulting</li>
              <li>GST Consulting</li>
              <li>Salary Packaging</li>
              <li>Taxation Advice</li>
            </ul>
          </Column>
          <Column className='services-bottom'>
            <p className='services-title'>SMSF Compliance &amp; Advice</p>
            <ul>
              <li>Fund Compliance and Administration Advice</li>
              <li>Contribution and Pension Tax Planning</li>
              <li>Advice on Property Purchases in SMSF</li>
              <li>Member Accounts and Estate Planning</li>
            </ul>
          </Column>
        </Row>
      </Page>
    );
  }
}

Services.contextType = GraingerAccountContext;
export default Services;